<div class="task-wrapper">
  <div class="task-name-icon">
    <ng-container *ngIf="isApproval(); else taskIcon">
      <mat-icon class="task-icon task-approve-icon">{{isApproval()}}</mat-icon>
    </ng-container>
    <ng-template #taskIcon>
      <mat-icon class="task-icon">edit</mat-icon>
    </ng-template>
    <div class="task-name">{{task.name}}</div>
  </div>

  <div class="task-owner">
    <framework-person-image *ngIf="task?.owner" [person]="task?.owner" size="1.5rem"> </framework-person-image>

    <div class="profile-name">{{task?.owner?.displayName}}</div>
  </div>
  <div class="task-due-edit">
    <div class="task-due-date">{{(task?.dueDate || task?.phaseEnd) | date:'d MMM, y' }}</div>
    <button styles-icon-button class="edit-button" (click)="openAction('ChangeDates')" *ngIf='hasAction("ChangeDates")'>
      <mat-icon>{{'ChangeDates' | actionIcon}}</mat-icon>
    </button>
  </div>

  <framework-work-status-chip class="task-status" [workStatus]="task?.status"></framework-work-status-chip>

  <div class="actions" *ngIf="task?.defaultAction || task.actions.length > 0">
    <button
      styles-icon-button
      class="action-button"
      (click)="openAction(task?.defaultAction?.actionEnum?.id)"
      *ngIf="task?.defaultAction && (task?.status?.id === 'BeingWorkedOn' || task?.status?.id === 'ReadyToWorkOn')"
    >
      <mat-icon>{{task?.defaultAction?.actionEnum?.id | actionIcon}}</mat-icon>
    </button>
    <framework-action-dropdown
      *ngIf="task.actions.length > 0"
      [actions]="task.actions"
      [location]="location"
      [task]="task"
      [phase]="phase"
      [project]="task | projectPipe"
    ></framework-action-dropdown>
  </div>
</div>
